import React, { ChangeEvent, FC } from 'react';

import * as Styled from './styled';
import { Props } from './types';

const Input: FC<Props> = ({
  name,
  label,
  id,
  error,
  placeHolder,
  type,
  notRequired,
  errorMessage,
  register,
  onInput,
  onChange,
  ...InputProps
}) => {
  const reactHookFormProps = register?.(name, { required: !notRequired });

  const handleInput = (event: ChangeEvent<HTMLInputElement>) =>
    reactHookFormProps?.onChange?.(event);

  return (
    <Styled.Container error={error}>
      <Styled.Label error={error} htmlFor={id}>
        {label}
      </Styled.Label>
      <Styled.Content error={error}>
        <Styled.Input
          {...reactHookFormProps}
          {...InputProps}
          onChange={onChange && onChange}
          onInput={onInput || handleInput}
          error={error}
          name={name}
          id={id}
          data-testid="test-input"
          placeholder={placeHolder}
          type={type && type}
        />
        {error && <Styled.Icon name="alert" data-testid="has-error" />}
      </Styled.Content>
      {error && <Styled.ErrorMessage> {errorMessage} </Styled.ErrorMessage>}
    </Styled.Container>
  );
};
export default Input;
